import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import { useForm, Controller } from "react-hook-form";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { CancelButton, SaveButton } from "../../../common/Button";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import JoditEditor from "jodit-react";
import {
  allUserhelpSubtype,
  allUserhelptype,
} from "../../../../utils/apis/masters/masters";
import classNames from "classnames";
library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);
  const editor = useRef(null);
  const id = props.show;
  const [country, setCountry] = useState([]);
  const [userHelpSubType, setUserHelpSubType] = useState([]);
  console.log(userHelpSubType,"userHelpSubType");
  const [formData, setFormData] = useState({
    id: "",
    question: "",
    answer: "",
    user_help_type_id: "",
    user_help_sub_type_id: "",
  });

  const {
    control,
    register,

    watch,
    getValues,
    formState: { errors },
    reset,
  } = useForm();

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleDescriptionChange = (value) => {
    setFormData({ ...formData, answer: value });
  };
  const handleChange = (e) => {
    if (e?.name == "user_help_type_id" || e?.name == "user_help_sub_type_id") {
      if (e?.name == "user_help_type_id") {
        setFormData({
          ...formData,
          [e.name]: e,
          user_help_sub_type_id: "",
        });
        getSelectedState(e.value);
      } else {
        setFormData({ ...formData, [e.name]: e });
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = await Validation.FormValidation({
      classname: ".stateclass",
    });

    const validationErrorsSelect = Validation.SelectValidation({
      classname: ".stateclass",
    });
    if (validationErrors && validationErrorsSelect) {
      try {
        const response = await postData(`/masters/user-help/${id}`, formData);
        if (response.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/masters/user-help/${id}`);

    setFormData(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  async function getSelectedState(id) {
    const response = await allUserhelpSubtype(id);

    if (response.success) {
      setUserHelpSubType(response.data);
    }
  }

  const GetAllCountry = async () => {
    const response = await allUserhelptype();
    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "user_help_type_id",
          label: data.name,
        });
      });
    }
    setCountry(option);
  };

  useEffect(() => {
    GetAllCountry();
  }, []);

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
    // fontSize: "11px",
  };
  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Edit State</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit User Help sub Type</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="stateclass"
                          >
                            <Row>
                              {/* <Col
                                lg={8}
                                md={10}
                                className=" mx-auto Add-content"
                              >
                                <Row> */}
                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="row justify-content-center mb-2">
                                    <Form.Label column sm={3}>
                                      User Help Type
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Select
                                        name="user_help_type_id"
                                        className="custom-select input-mandatory"
                                        value={formData?.user_help_type_id}
                                        options={country}
                                        onChange={handleChange}
                                      />{" "}
                                      <span className="error-message"></span>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>{" "}
                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="row justify-content-center mb-2">
                                    <Form.Label column sm={3}>
                                      User Help Sub Type{" "}
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Select
                                        name="user_help_sub_type_id"
                                        className="input-mandatory"
                                        onChange={handleChange}
                                        placeholder="Select User Help Sub Type"
                                        value={formData.user_help_sub_type_id}
                                        options={userHelpSubType.map(
                                          (stateOption) => ({
                                            value: stateOption.id,
                                            name: "user_help_sub_type_id",
                                            label: stateOption.name,
                                          })
                                        )}
                                      />
                                      <span className="error-message"></span>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      Question
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            name="question"
                                            value={formData?.question}
                                            onChange={handleChange}
                                            placeholder="Question "
                                            id="inputEmail3"
                                            className="input-mandatory"
                                          />
                                        </InputGroup>
                                        <span className="error-message"></span>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>{" "}
                              <Row>
                                <Col md={12}>
                                  <div className="main-form-section mt-2">
                                    <Row className="justify-content-center">
                                      <Form.Label column sm={3}>
                                        Answer
                                      </Form.Label>
                                      <Col sm={9}>
                                        <Form.Group>
                                          <InputGroup>
                                            <JoditEditor
                                              ref={editor}
                                              value={formData.answer}
                                              tabIndex={2}
                                              className="custom-jodit-editor"
                                              //onBlur={newContent=>setContent(newContent)}
                                              onChange={handleDescriptionChange}
                                            />
                                          </InputGroup>
                                          {errors?.answer && (
                                            <span style={errorStyle}>
                                              {errors?.answer}
                                            </span>
                                          )}
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                  </div>
                                </Col>
                              </Row>
                              {/* </Row> */}
                              <Row className="mt-5 pb-3">
                                <div className="d-flex justify-content-center">
                                  <Link>
                                    <CancelButton
                                      name={"cancel"}
                                      handleClose={props.handleClose}
                                    />
                                  </Link>
                                  <SaveButton
                                    name={"save"}
                                    handleSubmit={handleSubmit}
                                  />
                                </div>
                              </Row>
                              {/* </Col> */}
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
